"use strict";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const React = require('react');

const PropTypes = require('prop-types');

const SVGOSM = require('./svgosm.js'); //
// Pre-create the SVGOSM instance so it's shared between different icon
// instances that are created from the exported create function.
//


const svgosm = new SVGOSM('icon-svgosm');
/**
 * Generates our dedicated Icon component.
 *
 * @param {String} displayName Name of the Icon.
 * @returns {React.Component} The React Component.
 * @public
 */

module.exports = function create(displayName) {
  /**
   * The base component that renders the Icon.
   *
   * @constructor
   * @param {Object} props All the props
   * @param {Number} props.width Width of the icon.
   * @param {Number} props.height Height of the icon.
   * @param {String} props.title A11y title of the icon.
   * @param {String} props.desc A11y description of the icon.
   * @param {String} props.role A11y role for the icon.
   * @param {Object} props.props The rest of the props that are spread on the <use> tag.
   * @param {React.Ref} ref Forwarding reference
   * @private
   */
  const Fwd = React.forwardRef(function Icon(_ref, ref) {
    let {
      width,
      height,
      title,
      desc,
      role
    } = _ref,
        props = _objectWithoutProperties(_ref, ["width", "height", "title", "desc", "role"]);

    const res = svgosm.get(displayName, function extract() {
      const node = svgosm.node(); //
      // There would be no node available during SSR, bail out early.
      //

      if (!node) return;
      const details = svgosm.extract(node, `uxp-icon-${displayName}`);
      if (!details) return;
      return Object.assign(details, {
        title: title,
        desc: desc
      });
    });
    if (!res) return null;
    const svg = {
      className: 'uxicon-svg-container',
      height: height || res.height,
      width: width || res.width,
      role,
      ref
    };
    return /*#__PURE__*/React.createElement("svg", svg, /*#__PURE__*/React.createElement("use", _extends({
      fill: "currentColor"
    }, props, {
      xlinkHref: res.link
    })));
  }); //
  // Ease debugging.
  //

  Fwd.displayName = displayName + 'Icon';
  /**
   * PropType validation.
   *
   * @type {Object}
   * @private
   */

  Fwd.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    desc: PropTypes.string,
    title: PropTypes.string,
    role: PropTypes.string
  };
  /**
   * Default properties.
   *
   * @type {Object}
   * @private
   */

  Fwd.defaultProps = {
    role: 'img',
    width: '1.5em',
    height: '1.5em'
  };
  return Fwd;
};